import { dayjs, Dayjs } from "@holibob-packages/dayjs";

import { CancellationPenalty } from "./types";

export const MAX_DURATION = "P10Y";

export type ComputeEffectiveCancellationPenaltyProps = {
    penaltyList: CancellationPenalty[];
    dNow: Dayjs;
    dBookingDate: Dayjs;
    dStartAt: Dayjs;
};

export function computeEffectiveCancellationPenalty({
    penaltyList,
    dNow,
    dBookingDate,
    dStartAt,
}: ComputeEffectiveCancellationPenaltyProps): CancellationPenalty | undefined {
    let effectivePenalty;

    const listSorted = penaltyList
        .map((penalty) => {
            const { relativeTo } = penalty;
            const duration = penalty.duration ? penalty.duration : MAX_DURATION;
            const dDuration = dayjs.duration(duration);

            let dEndDate = dStartAt;
            let dStartDate = dStartAt.subtract(dDuration);

            if (relativeTo === "BOOKING_DATE") {
                dStartDate = dBookingDate;
                dEndDate = dStartDate.add(dDuration);
            }

            const isActive =
                (dNow.isSame(dStartDate, "minutes") || dNow.isAfter(dStartDate, "minutes")) &&
                (dNow.isSame(dEndDate, "minutes") || dNow.isBefore(dEndDate, "minutes"));

            const range = `${dStartDate.toISOString()} - ${dEndDate.toISOString()}`;

            return {
                penalty,
                isActive,
                dStartDate,
                range,
            };
        })
        .sort((a, b) => {
            if (a.penalty.relativeTo === "TRAVEL_DATE") {
                return b.dStartDate.diff(a.dStartDate);
            }
            return a.dStartDate.diff(b.dStartDate);
        });

    for (const item of listSorted) {
        if (item.isActive) {
            effectivePenalty = item.penalty;
            break;
        }
    }

    return effectivePenalty;
}
